import React from 'react';
import { FormControl, InputV2 } from '@withjoy/joykit';
import { FormikProps } from 'formik';
import { PlaceToStayFormFields } from '../PlaceToStayForm.types';
import { useFieldErrors } from '@shared/createEvent/hooks/useFieldErrors';
import { useTranslation } from '@shared/core';

interface PlaceToStayManualFieldsProps
  extends Readonly<{
    formik: FormikProps<PlaceToStayFormFields>;
  }> {}

export const PlaceToStayManualFields: React.FC<PlaceToStayManualFieldsProps> = ({ formik }) => {
  const { tq } = useTranslation('placeToStayComponent');
  const getFieldErrorProps = useFieldErrors<PlaceToStayFormFields>(formik);

  return (
    <>
      <FormControl
        width="100%"
        marginTop={2}
        label={tq`Name`}
        isRequired={false}
        {...getFieldErrorProps('customName')}
      >
        <InputV2
          {...formik.getFieldProps('customName')}
          {...getFieldErrorProps('customName')}
        />
      </FormControl>

      <FormControl
        width="100%"
        marginTop={2}
        label={tq`Location`}
        isRequired={false}
        {...getFieldErrorProps('address')}
      >
        <InputV2
          {...formik.getFieldProps('address')}
          {...getFieldErrorProps('address')}
          isDisabled
        />
      </FormControl>

      <FormControl
        width="100%"
        marginTop={2}
        label={tq`Link`}
        isRequired={false}
        {...getFieldErrorProps('customUrl')}
      >
        <InputV2
          {...formik.getFieldProps('customUrl')}
          {...getFieldErrorProps('customUrl')}
          placeholder={tq`Booking link`}
        />
      </FormControl>
    </>
  );
};
